import Link from "next/link";
import { landingContent } from "@/content/landing";
import { scrollToAnchor } from "@/lib/scroll-to-anchor";

export interface NavLink {
  label: string;
  href: string;
}

export const PAGE_LINKS: NavLink[] = landingContent.nav.pageLinks;

export const LANDING_LINKS: NavLink[] = landingContent.nav.landingLinks;

export { PAGE_LINKS as DEFAULT_LINKS };

interface NavLinksProps {
  links?: NavLink[];
  className?: string;
  onLinkClick?: (label: string) => void;
  /** Use anchor links for Features/Pricing sections */
  isLanding?: boolean;
}

export function NavLinks({ links, isLanding, className = "", onLinkClick }: NavLinksProps) {
  const resolved = links ?? (isLanding ? LANDING_LINKS : PAGE_LINKS);

  return (
    <nav className={`flex items-center gap-[40px] ${className}`}>
      {resolved.map((link) => (
        <Link
          key={link.label}
          href={link.href}
          onClick={(e) => {
            onLinkClick?.(link.label);
            // Scroll anchors ourselves: the router skips the scroll when the
            // fragment is unchanged, which kills the link after the reader
            // scrolls away from the section.
            if (link.href.startsWith("#") && scrollToAnchor(link.href)) e.preventDefault();
          }}
          className="overflow-clip rounded-[12px] px-[8px] py-[6px] shrink-0 transition-colors hover:bg-black/5"
        >
          <span
            className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[20px] text-text whitespace-nowrap"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {link.label}
          </span>
        </Link>
      ))}
    </nav>
  );
}
